<template>
  <div class="search-detaile table-def-pg">
    <div class="search-pg">
      <Search />
    </div>
    <div class="breadcrumb-wrap">
      <div class="container">
        <v-breadcrumbs :items="breadcrumbs" />
      </div>
    </div>
    <div class="container">
      <div class="position">
        <div class="bg-white p-20">
          <div class="search-body">
            <div class="search-result">
              <div>
                <div class="search-result-body">
                  <div class="type-column">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>
                              {{ $t('Наименование') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="category in categories" :key="category.id">
                            <td>
                              <img
                                class="category-img"
                                v-if="
                                  category.icon !== null && category.icon !== ''
                                "
                                :src="baseUrl + category.fullFilesDirectory"
                                alt=""
                              />
                              <router-link
                                :to="$i18nRoute({ name: 'search-npa', query: { category: category.id } })"
                                :key="category.id"
                              >
                                {{ category.transName }}
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>
                <div class="search-result-footer">
                  <p>{{ $t('Общее количество') }}: {{ categoriesTotal }}</p>
                </div>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="pagesCount"
              total-visible="10"
              @input="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CMS from '@/model/cms'
import { mapMutations } from 'vuex'
import Search from '@/components/Search'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Search
  },
  data: () => ({
    page: 1,
    pagesCount: 0,
    categories: [],
    breadcrumbs: [],
    categoriesTotal: 0,
    baseUrl: process.env.VUE_APP_BACK_URL
  }),
  watch: {
    '$route.query'(qs) {
      this.fetchData(qs)
    }
  },
  metaInfo () {
    return {
      title: this.$i18n.t('NPACategoriesTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('NPACategoriesDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('NPACategoriesKeywordsSEO'),
      }]
    }
  },
  created() {
    this.page =
      Number(this.$route.query.page) > 0
        ? Number(this.$route.query.page)
        : this.page
    this.fetchData(this.$route.query)
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData(qs) {
      this.setLoading(true)
      CMS.getNpaCategories(this.page)
        .then((response) => {
          this.categories = response.data.items
          const paginator = response.data.paginationData
          this.pagesCount = paginator.pageCount
          this.categoriesTotal = paginator.totalCount
          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/' }
          ]

          if (response.data.parentMenu) {
            const breadcrumb = {}
            breadcrumb.text = response.data.parentMenu.transName
            breadcrumb.disabled = true
            this.breadcrumbs.push(breadcrumb)
          }
          this.setLoading(false)
        })
        .catch((error) => {
          //console.log(error)
        })
    },
    changePage(page) {
      this.$router.push({ query: { ...this.$route.query, page } })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
